import { FilterKey } from '@studyportals/search-filters';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { IFilterOptions } from './IFilterOptions';

export abstract class FilterOptionsBase implements IFilterOptions {
	private options: FilterOptionInformation[] | null = null;

	public supports(key: FilterKey): boolean {
		return this.getFilterKey() === key;
	}

	public isValid(value: string): boolean {
		return this.determineOptions().some((o) => o.optionValue === value);
	}

	public determineOptions(): FilterOptionInformation[] {
		if (this.options !== null) {
			return this.options;
		}

		return (this.options = this.createOptions());
	}

	public isRequired(): boolean {
		return false;
	}

	public abstract createOptions(): FilterOptionInformation[];

	public abstract getFilterKey(): FilterKey;
}
